import { render, staticRenderFns } from "./creditos.vue?vue&type=template&id=2109af9b&scoped=true&"
import script from "./creditos.vue?vue&type=script&lang=js&"
export * from "./creditos.vue?vue&type=script&lang=js&"
import style0 from "./creditos.vue?vue&type=style&index=0&id=2109af9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2109af9b",
  null
  
)

export default component.exports